import React from 'react';
import UserService from '../../components/auth/UserService';
import settingsService from '../../services/settingsService';
import { FeatureFlagsProvider } from '@lms/react-configuration/context/feature-flags';

const FeatureFlagWrapper = ({ children }) => {
    const configurationApiBaseAddress = settingsService.settings.configurationApiBaseAddress;
    const acquireAccessToken = async () => await UserService.getAccessToken(settingsService.authConfig);

    return (
        <FeatureFlagsProvider
            url={configurationApiBaseAddress}
            getAccessToken={acquireAccessToken}
            featurePrefix="Confirmly.UI."
        >
            {children}
        </FeatureFlagsProvider>
    );
};

export default FeatureFlagWrapper;